import React, { useCallback, useState } from 'react';
import momentjs from 'moment';
import { useLocation } from 'react-router-dom';
import styled from '@emotion/styled';

// custom hook to get the current pathname in React

const Notification = styled.div`
  margin-top: 15px;
  margin-bottom: 20px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: #d9edf7;
  border-color: #bce8f1;
  color: #31708f;
  padding: 15px;
  .close {
    float: right;
    background-color: transparent;
    border: transparent;
    font-size: 21px;
    padding: 0;
    line-height: 1;
  }
`;

const usePathname = () => {
  const location = useLocation();
  return location.pathname;
};

const PriceChangeNotification = () => {
  const isOrdersPage = usePathname() === '/orders';
  const isAlertExpired = momentjs().diff(momentjs('2022-05-16')) > 0;
  const [hasToDisplayAlert, setHasToDisplayAlert] = useState(
    !isAlertExpired && !localStorage.getItem('hide-customer-alert')
  );

  const closeNotification = useCallback(() => {
    localStorage.setItem('hide-customer-alert', true);
    setHasToDisplayAlert(false);
  }, []);
  return (
    <>
      {isOrdersPage && hasToDisplayAlert ? (
        <Notification>
          <button
            onClick={() => closeNotification()}
            type="button"
            class="close"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
          <strong>PLEASE NOTE:</strong> On April 4, 2022, price changes for some hardware products
          take effect. Please consult your sales representative if you have questions.
        </Notification>
      ) : null}
    </>
  );
};

export { PriceChangeNotification };
